import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/zengdai/Workspace/vimwiki/Projects/Blogger/blogv3/src/components/posts-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`One simple improvement that solves my previous ssh copy pain on remote vim...`}</p>
    <h1>{`Just Three Functions`}</h1>
    <p>{`In your Vim config:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "vim"
    }}><pre parentName="div" {...{
        "className": "language-vim"
      }}><code parentName="pre" {...{
          "className": "language-vim"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`function`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`!`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`GetVisualSelection`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
  `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`try`}</span>{`
    `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`let`}</span>{` a_save `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` @a
    normal`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`!`}</span>{` gv`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`"ay`}</span>{`
    `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`return`}</span>{` @a
  `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`finally`}</span>{`
    `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`let`}</span>{` @a `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` a_save
  `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`endtry`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`endfunction`}</span>{`

`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`function`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`CopyToNetCat`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` range
    `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`let`}</span>{` selected_lines `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`GetVisualSelection`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
    echo `}<span parentName="code" {...{
            "className": "token function"
          }}>{`system`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`'printf "%s" '`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`shellescape`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`selected_lines`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`' | nc localhost 2000'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`endfunction`}</span></code></pre></div>
    <p>{`and probably bind it like this:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "vim"
    }}><pre parentName="div" {...{
        "className": "language-vim"
      }}><code parentName="pre" {...{
          "className": "language-vim"
        }}>{`vnoremap `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span>{`C`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`-`}</span><span parentName="code" {...{
            "className": "token keyword"
          }}>{`y`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token keyword"
          }}>{`call`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`CopyToNetCat`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span>{`CR`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span></code></pre></div>
    <p>{`In your Mac shell script (Linux should replace `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`pbcopy`}</code>{` with `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`xclip -sel clip`}</code>{` or `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`xsel -i -b `}</code>{`):`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token function-name function"
          }}>{`ssh_copy`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
    `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`while`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`!`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`nc `}<span parentName="code" {...{
            "className": "token parameter variable"
          }}>{`-l`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`2000`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`|`}</span>{` pbcopy`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`||`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean"
          }}>{`true`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`do`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`done`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`
    `}<span parentName="code" {...{
            "className": "token assign-left variable"
          }}>{`copy_daemon`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token variable"
          }}>{`$!`}</span>{`
    `}<span parentName="code" {...{
            "className": "token function"
          }}>{`ssh`}</span>{` `}<span parentName="code" {...{
            "className": "token variable"
          }}>{`$@`}</span>{` `}<span parentName="code" {...{
            "className": "token parameter variable"
          }}>{`-R`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`2000`}</span>{`:localhost:2000
    `}<span parentName="code" {...{
            "className": "token function"
          }}>{`pkill`}</span>{` `}<span parentName="code" {...{
            "className": "token parameter variable"
          }}>{`-9`}</span>{` `}<span parentName="code" {...{
            "className": "token parameter variable"
          }}>{`-g`}</span>{` `}<span parentName="code" {...{
            "className": "token variable"
          }}>{`$copy_daemon`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>
    <p>{`Now, you login with `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`ssh_copy user@server`}</code>{` instead of normal `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`ssh`}</code>{` to remote and have fun there with `}<kbd>{`Ctrl`}</kbd>{`+`}<kbd>{`y`}</kbd>{`. Also feel free to change the port number if `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`2000`}</code>{` is too familar to you. `}</p>
    <h1>{`If Multiple SSH Sessions Bother You`}</h1>
    <p>{`Just forcefully kick out your dups session:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token function-name function"
          }}>{`ssh_copy`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
    `}<span parentName="code" {...{
            "className": "token builtin class-name"
          }}>{`echo`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"Make sure you setup password free by doing: ssh-copy-id id@server"`}</span>{`
    `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`# clean all other ssh session`}</span>{`
    `}<span parentName="code" {...{
            "className": "token function"
          }}>{`ssh`}</span>{` `}<span parentName="code" {...{
            "className": "token variable"
          }}>{`\${1}`}</span>{` `}<span parentName="code" {...{
            "className": "token parameter variable"
          }}>{`-t`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'ps -aux | grep "[s]sh" | grep pts/ | grep -v $(ps --no-headers -fp $$ | awk "{print \\$3}") | awk "{print \\$2}" | xargs kill -9'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`while`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`!`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`nc `}<span parentName="code" {...{
            "className": "token parameter variable"
          }}>{`-l`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`2000`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`|`}</span>{` pbcopy`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`||`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean"
          }}>{`true`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`do`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`done`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`
    `}<span parentName="code" {...{
            "className": "token assign-left variable"
          }}>{`copy_daemon`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token variable"
          }}>{`$!`}</span>{`
    `}<span parentName="code" {...{
            "className": "token function"
          }}>{`ssh`}</span>{` `}<span parentName="code" {...{
            "className": "token variable"
          }}>{`\${1}`}</span>{` `}<span parentName="code" {...{
            "className": "token parameter variable"
          }}>{`-R`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`2000`}</span>{`:localhost:2000 `}<span parentName="code" {...{
            "className": "token parameter variable"
          }}>{`-t`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'tmux a || $SHELL '`}</span>{`
    `}<span parentName="code" {...{
            "className": "token function"
          }}>{`pkill`}</span>{` `}<span parentName="code" {...{
            "className": "token parameter variable"
          }}>{`-9`}</span>{` `}<span parentName="code" {...{
            "className": "token parameter variable"
          }}>{`-g`}</span>{` `}<span parentName="code" {...{
            "className": "token variable"
          }}>{`$copy_daemon`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>
    <h1>{`Bonus: No +clipboard or DISPLAY`}</h1>
    <p><strong parentName="p">{`Symptoms`}</strong>{`: SSHed in the same remote server, with no `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`+clipboard`}</code>{` or `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`$DISPLAY`}</code>{`, thus `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`unamedplus`}</code>{`, `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`xsel`}</code>{` or `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`xclip`}</code>{` would not work in different tmux session etc.`}</p>
    <p><strong parentName="p">{`Treatment`}</strong>{`: ancient/traditional copy via tmp files. Map keys to these functions.`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "vim"
    }}><pre parentName="div" {...{
        "className": "language-vim"
      }}><code parentName="pre" {...{
          "className": "language-vim"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`function`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`CopyToTmpBuffer`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` range
    `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`let`}</span>{` selected_lines `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`GetVisualSelection`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
    echo `}<span parentName="code" {...{
            "className": "token function"
          }}>{`system`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`'printf "%s" '`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`shellescape`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`selected_lines`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`' > ~/.config/nvim/backup/.vim-buf'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`endfunction`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`function`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`PasteFromTmpBuffer`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
    `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`try`}</span>{`
        `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`let`}</span>{` a_save `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` @a
        `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`let`}</span>{` @a `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`system`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`'cat ~/.config/nvim/backup/.vim-buf'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
        normal`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`!`}</span>{` `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`"ap`}</span>{`
    `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`finally`}</span>{`
        `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`let`}</span>{` @a `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` a_save
    `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`endtry`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`endfunction`}</span></code></pre></div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      